// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import './polyfill'
// import cssVars from 'css-vars-ponyfill'
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router/index'
import store from './store'
import Axios from 'axios'
import VueColumnsResizable from './libs/table-resize';
import VueTheMask from 'vue-the-mask';
import 'viewerjs/dist/viewer.css'
import accounting from "accounting";
import { notificationV2, formatDateLift, validationData } from "@/_commonVar.js";
import { modules } from '@/_role_modules.js';
import * as VueGoogleMaps from 'vue2-google-maps';

import VueAuthImage from 'vue-auth-image';

// Globally Registered Components
import './globalComponents.js'

// Globally Registered Filters
import './filters.js'
import VueSignaturePad from 'vue-signature-pad';

Vue.use(BootstrapVue)
Vue.use(VueTheMask);
Vue.use(VueColumnsResizable);

Vue.use(VueGoogleMaps, {
    load: {
      key: process.env.VUE_APP_KEY_GOOGLE_MAP,
      libraries: 'places'
    },
    installComponents: true
  })

 // register vue-auth-image directive
Vue.use(VueAuthImage);
Vue.use(VueSignaturePad);
// set Authorization header used by axios
// var authHeader = 'Bearer ' + localStorage.getItem('id_token');
// Axios.defaults.headers.common['Authorization'] = authHeader; 

Axios.defaults.baseURL = process.env.VUE_APP_SERVER_URL || 'https://fm-api-dev.gofix.com.sg'

Axios.interceptors.response.use(
    (response) =>{
        return response;
    }, 
    (error) => {
        const { response } = error
        const originalRequest = error.config
        if (response && response.status === 403) {
            if(localStorage.getItem('access_token')) {
                if(goFix){
                    goFix._logout();
                }else{
                    store.dispatch('AuthController/logout')
                }
                localStorage.clear();
                store.reset();
            }
            return;
        }
        if (response && response.status === 422) {
            const vm = new Vue()
            let msg = response.data.error.message
            if(response.config && response.config.url) {
                let pattern = /\/api\/case-hot-button(\/\d+)?/i;
                if(pattern.test(response.config.url)) {
                    msg = msg.replace("Feedback Detail", "Issue")
                }
            }
            vm.$alertNotification(msg, "danger")
            return Promise.reject({});
        }
        if (response && response.status === 401) {
            // Auto call refresh token
            if(!originalRequest._retry){
                if(goFix){
                    goFix.refreshToken();
                    originalRequest._retry = true
                    const token = goFix.getToken();
                    originalRequest.headers.Authorization = `Bearer ${token}`
                    return Axios(originalRequest)
                }
            }else {
                if(goFix){
                    goFix._logout();
                }
                store.dispatch('AuthController/logout')
                localStorage.clear();
                store.reset();
            }

        }
      return Promise.reject(error)
})

global.axios = Axios
const accessToken = localStorage.getItem('access_token');
if (accessToken)
    global.axios.defaults.headers.common['Authorization'] = 'Bearer ' + accessToken;

global.axios.defaults.headers["app-token"] = "fvedoSam1DJWaq7X78oraW03UBilsXPO";

// Globally Registered Variable
Vue.prototype.$accessModule = modules;
Vue.prototype.$notificationV2 = notificationV2;
Vue.prototype.$formatDateLift = formatDateLift;
Vue.prototype.$accounting = accounting;
Vue.prototype.$roles = JSON.parse(localStorage.getItem('user_roles')) || null;
Vue.prototype.$users = JSON.parse(localStorage.getItem('user_info')) || null;
Vue.prototype.$attrVCalendar = [{
    key: 'today',
    contentStyle: {
        color: '#F22B1E'
    },
    dates: new Date(),
}];

Vue.directive('click-outside', {
    bind: function(el, binding, vnode) {
        el.clickOutsideEvent = function(event) {
            // here I check that click was outside the el and his childrens
            if (!(el == event.target || el.contains(event.target))) {
                // and if it did, call method provided in attribute value
                vnode.context[binding.expression](event);
            }
        };
        document.body.addEventListener('click', el.clickOutsideEvent)
    },
    unbind: function(el) {
        document.body.removeEventListener('click', el.clickOutsideEvent)
    },
});

Vue.prototype.$validationData = validationData;

// Mixin
import { mapGetters } from 'vuex';
Vue.mixin({
    computed: {
        ...mapGetters({
            UserLogin: "AuthController/user",
            ClientContractID: 'ContractController/ClientContractID',
            roles: 'AuthController/roles',
        }),
    },
    methods: {
        $checkRole(access, action, property_lft) {
            let userRoles = this.roles || JSON.parse(localStorage.getItem('user_roles'));
            if (!userRoles) {
                return false;
            }
            if (userRoles.is_super) return true;
            if (property_lft) {
                //Check roles with property
                let userRole = userRoles.data.find(e => (e.lft <= property_lft && e.rgt >= property_lft));
                let roles = userRole ? userRole.roles : null;
                if (!roles || (access && (!access.session || !access.module))) return false;
                if (!access) {
                    return true
                }
                let module_key = access.session.toLowerCase() + "-" + access.module.toLowerCase();
                if(!roles[module_key]) return false;
                if (!!roles[module_key][action]) return !!roles[module_key][action];
            }

            for (let i = 0; i < userRoles.data.length; i++) {
                let roles = userRoles.data[i].roles;
                if (!roles || !access || !access.session || !access.module) continue;
                let module_key = access.session.toLowerCase() + "-" + access.module.toLowerCase();
                if(!roles[module_key]) return false;
                if (!!roles[module_key][action]) return !!roles[module_key][action];
            }
            return false;
        },
        $userRoleNames() {
            let users = this.UserLogin || JSON.parse(localStorage.getItem('user_info'));
            let roles = users && users.roles ? users.roles : [];
            return roles.map(role => (role.name || '').trim().toLowerCase());
        },
        $hasApproverRole() {
            return this.$userRoleNames().includes('approver');
        },
        $isOnlyApprover() {
            let roleNames = this.$userRoleNames();
            return roleNames.length === 1 && roleNames[0] === 'approver';
        },
        // Approver without update permission from other roles: only Approve/Reject
        $isApproverAccessOnly(access) {
            return this.$isOnlyApprover() || (this.$hasApproverRole() && !this.$checkRole(access, 'update'));
        },
        $disabledCreateOrUpdate(model, access_module) {
            // Check type of string for selected node id of tree. ie: service_category
            if (model.id == undefined || typeof(model.id) == "string") {
                return !this.$checkRole(access_module, 'create');
            } else {
                return !this.$checkRole(access_module, 'update');
            }
        },
        $alertNotification(message = "", status = "success", title = "Notification") {
            this.$bvToast.toast(message, {
                title: title,
                autoHideDelay: 3000,
                variant: status,
                solid: true
            })
        },
        $checkSupplier(){
            let users = this.UserLogin || this.$users || JSON.parse(localStorage.getItem('user_info'));
            if(users && users.organization && users.organization.is_supplier){
                return true;
            }
            return false;
        },
        $checkTwoFactorAuth(){
            let users = this.UserLogin || this.$users || JSON.parse(localStorage.getItem('user_info'));
            if(users && ((users.mfa_required && !users.microsoft2fa_enable && !users.session_twofa) || (users.mfa_required && users.session_twofa) || (!users.mfa_required && users.microsoft2fa_enable && users.session_twofa))){
                return false;
            }
            return true;
        }
    }
});

/* eslint-disable no-new */
new Vue({
    store,
    el: '#app',
    router,
    template: '<App/>',
    components: {
        App
    }
});